export enum AppNavigationOptionsEnum {
    MY_STRAINS_LISTING = 'my-strains-myStrains',
    MY_STRAINS_GENE_MUTATIONS = 'my-strains-geneMutations',

    MOUSE_INTELLIGENCE_PROJECTS = 'mouse-intelligence-projects',
    MOUSE_INTELLIGENCE_COLONY_EVALUATION = 'mouse-intelligence-colony-evaluation',

    MY_CAGES_LISTING = 'my-cages-listing',
    MY_CAGES_MAP_VIEW = 'my-cages-map-view',
    MY_CAGES_WORKBENCH = 'my-cages-workbench',

    ADMINISTRATION_TICKET_LAB = 'administration-ticket-lab',
    ADMINISTRATION_USERS = 'administration-users',
    ADMINISTRATION_GROUPS = 'administration-groups',
    ADMINISTRATION_AUDIT_LOG = 'administration-audit-log',
    ADMINISTRATION_MOUSE_IMPORT = 'administration-mouse-import',
    ADMINISTRATION_RELOAD_GROUP_DATA = 'administration-reload-group-data',
    ADMINISTRATION_BANNER_MAINTENANCE = 'administration-banner-maintenance',
    ADMINISTRATION_SCHEDULED_JOBS = 'administration-scheduled-jobs',
}
